var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72375 7.22362C9.26256 7.22362 10.51 5.97618 10.51 4.43737C10.51 2.89857 9.26256 1.65112 7.72375 1.65112C6.18494 1.65112 4.9375 2.89857 4.9375 4.43737C4.9375 5.97618 6.18494 7.22362 7.72375 7.22362Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9503 17.2409C15.9503 18.2667 15.1187 19.0982 14.0929 19.0982C13.067 19.0982 12.2354 18.2667 12.2354 17.2409C12.2354 16.2149 13.067 15.3833 14.0929 15.3833C15.1187 15.3833 15.9503 16.2149 15.9503 17.2409Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8489 13.9904C22.8489 15.0163 22.0172 15.8479 20.9913 15.8479C19.9655 15.8479 19.1338 15.0163 19.1338 13.9904C19.1338 12.9646 19.9655 12.1329 20.9913 12.1329C22.0172 12.1329 22.8489 12.9646 22.8489 13.9904Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8489 20.4914C22.8489 19.4656 22.0172 18.634 20.9913 18.634C19.9655 18.634 19.1338 19.4656 19.1338 20.4914C19.1338 21.5174 19.9655 22.349 20.9913 22.349C22.0172 22.349 22.8489 21.5174 22.8489 20.4914Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3868 19.555L15.6846 18.1765",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3868 14.9261L15.6846 16.3046",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2691 21.0147L10.1121 22.3489H5.33565L4.53958 15.5823H2.15137V12.796C2.15137 9.7184 4.64625 7.22351 7.72387 7.22351C10.4464 7.22351 12.7129 9.17594 13.1997 11.757",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.48a34df41ef92471ebb2f7cce6cb2545.svg";
export { ForwardRef as ReactComponent };